__turbopack_context__.v({
  "article-card": "ArticleCard-module-scss-module__YOnXIW__article-card",
  "author": "ArticleCard-module-scss-module__YOnXIW__author",
  "content": "ArticleCard-module-scss-module__YOnXIW__content",
  "default-img-wrapper": "ArticleCard-module-scss-module__YOnXIW__default-img-wrapper",
  "thumbnail": "ArticleCard-module-scss-module__YOnXIW__thumbnail",
  "thumbnail-wrapper": "ArticleCard-module-scss-module__YOnXIW__thumbnail-wrapper",
  "title": "ArticleCard-module-scss-module__YOnXIW__title",
});
